// extracted by mini-css-extract-plugin
module.exports = {"root":"IconEnquiry_root__LqXxT","marketplaceColorStroke":"IconEnquiry_marketplaceColorStroke__1CJuO"};